// extracted by mini-css-extract-plugin
module.exports = {"container":"CalendarView_container__3zUxg","calendar":"CalendarView_calendar__a3AkK"};